import React, { useEffect } from 'react';
import useApp from 'hooks/useApp'
import styles from './index.module.css'

const HomeDetailNeighborhoodRent = () => {

	const App = useApp()

	useEffect(() => {
		App.setHeader({
			show: true,
			title: <></>,
			left: "",
			right: <i className="icon icon_close" />
		})

		App.setShowNav(false)
		App.setMainClass("white")
	}, [])

	return (
		<div className="page">
			<div className="shadow">
				<div className="padding pb_50">
					<div className={styles["home-address"]}>
						경기 성남시 분당구 판교역로 235<i className="icon icon_copy ml_5" />
					</div>
					<div className={`${styles["home-title"]} mt_5`}>에이치스퀘어 엔동</div>
					<div className={`${styles["tag-area"]} mt_10`}>
						<i className="tag tag-box tag-gray normal">아파트</i>
						<i className="tag tag-box tag-gray normal">월세</i>
					</div>
					<ul className="my-info-box mt_30" style={{ padding: "2rem 1rem" }}>
						<li>
							<span>최저금액</span>
							<strong className="text-blue">1,000만원</strong>
						</li>
						<li>
							<span>최고금액</span>
							<strong className="text-red">1억 2,000만원</strong>
						</li>
					</ul>
				</div>
			</div>

			<div className={`${styles["transaction-list"]} pt_40`}>
				<div>
					<p className={styles.date}>10월 25일 (월)</p>
					<ul className="list-bg">
						<li>
							<div className={styles.info}>
								<span>10층</span>
								<span>76.26㎡</span>
							</div>
							<div className="text-align_right">
								<div className={styles.price}>1,500만원</div>
								<span className={`${styles.rent} mt_5`}>70만원</span>
							</div>
						</li>
						<li>
							<div className={styles.info}>
								<span>5층</span>
								<span>76.26㎡</span>
							</div>
							<div className="text-align_right">
								<div className={styles.price}>1억 2,000만원</div>
								<span className={`${styles.rent} mt_5`}>70만원</span>
							</div>
						</li>
					</ul>
				</div>
				<div>
					<p className={styles.date}>10월 25일 (월)</p>
					<ul className="list-bg">
						<li>
							<div className={styles.info}>
								<span>10층</span>
								<span>76.26㎡</span>
							</div>
							<div className="text-align_right">
								<div className={styles.price}>1,500만원</div>
								<span className={`${styles.rent} mt_5`}>70만원</span>
							</div>
						</li>
					</ul>
				</div>
			</div>
		</div>
	)
}

export default HomeDetailNeighborhoodRent